<template>
  <template  v-if="shouldDisplay()">
    <slot></slot>
  </template>
</template>

<script>
export default {
  name: "IsManager",
  data() {
    return {
      roles: [
          'Admin',
          'Manager',
      ]
    }
  },
  methods: {
    shouldDisplay() {
      return this.roles.includes(this.userRole)
    }
  },
  computed: {
    userRole() {
      return this.$store.getters.getGravyUserRole
    }
  }
}
</script>

<style scoped>

</style>